import React from 'react';
import Icon from '../../../components/AppIcon';

const SummaryCard = ({ title, value, subtitle, icon, iconColor, trend, trendValue, onClick }) => {
  const getTooltipText = () => {
    if (title?.toLowerCase()?.includes('compliance')) {
      return 'Overall Compliance: Percentage of sites meeting all compliance requirements';
    }
    if (title?.toLowerCase()?.includes('expiring')) {
      return 'Expiring Documents: Number of documents expiring within the next 30 days';
    }
    return title;
  };

  const cardClasses = `bg-card rounded-lg p-4 md:p-6 shadow-elevation-2 border border-border ${
    onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''
  }`;

  return (
    <div 
      className={cardClasses} 
      title={getTooltipText()}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          onClick();
        }
      } : undefined}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-caption mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground font-heading">{value}</h3>
          {subtitle && (
            <p className="text-xs md:text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${iconColor}`}>
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-1 mt-2">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
          />
          <span className={`text-xs md:text-sm font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            {trendValue}
          </span>
        </div>
      )}
    </div>
  );
};

export default SummaryCard;